import { createGlobalStyle } from "styled-components";

const Global = createGlobalStyle`
  *{
    font-family: 'Montserrat', sans-serif;
  }

  body {
      margin: 0;
      padding: 0;
  }

  .container {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
`;

export default Global;
